jQuery(document).ready(function ($) {
    $(document).ready(function() {
        // Toggle functionality for all links
        $('.toggle-link').click(function() {
            var sectionId = $(this).data('section');

            // Remove the active class from all sections and links
            $('.toggle-section').removeClass('active');
            $('.toggle-link').removeClass('active');

            // Add the active class to the clicked link and its corresponding section
            $('#' + sectionId).addClass('active');
            $(this).addClass('active');
        });
    });
// viewmore button
const charLimit = 150; // Character limit before truncating

$('.text').each(function () {
    const textElement = $(this);
    const originalText = textElement.text();

    if (originalText.length > charLimit) {
        const visibleText = originalText.substring(0, charLimit);
        const hiddenText = originalText.substring(charLimit);

        // Wrap visible and hidden parts of the text
        textElement.html(`${visibleText}<span class="hidden-text">${hiddenText}</span>`);

        // Create and append the "View More" link
        const viewMoreLink = $('<a href="#" class="view-more-link">View More>...</a>');
        textElement.after(viewMoreLink);

        viewMoreLink.show(); // Show the link if text is truncated

        viewMoreLink.on('click', function (e) {
            e.preventDefault();
            const hiddenTextElement = textElement.find('.hidden-text');
            if (hiddenTextElement.is(':visible')) {
                hiddenTextElement.hide();
                viewMoreLink.text('View More>...');
            } else {
                hiddenTextElement.show();
                viewMoreLink.text('View Less');
            }
        });
    }
});


});


